module.exports = __webpack_public_path__ + "img/web3.34128595.webp";